export const HeaderHeight = 55;
export const ItemHeight = 50;
export const ValidationHeight = 0;
export const SidePadding = 30;
export const MaxBodyHeight = 240;